export enum NamedServices {
  'ImporterService' = 'ImporterService',
  'ReadmissionService' = 'ReadmissionService',
  'PdfService' = 'PdfService',
  'YearService' = 'YearService',
  'UserPreferencesService' = 'UserPreferencesService',
  'CentrePreferencesService' = 'CentrePreferencesService',
}